$(function() {

  $('.js-validate').blur(function(e) {
    $('.error').remove();
    $('.error_php').remove();

    const target = $(e.currentTarget);
    switch (target.attr('name')) {
      case 'company_name':
      case 'department_name':
      case 'manager_name':
        const requiredBox = required(target);
        if(requiredBox) {
          target.after(`<p class="error">※${target.attr('data-valiName')}は${requiredBox}</p>`);
        } else {
          target.siblings('.error').remove();
        }
        break;
      case 'company_furi':
        if($(target).val()) {
          const furiganaVali = furigana(target);
          target.siblings('.error').remove();
          if(furiganaVali) {
            target.after(`<p class="error">※${target.attr('data-valiName')}は${furiganaVali}</p>`);
          } else {
            target.siblings('.error').remove();
          }
        } else {
          target.siblings('.error').remove();
          const furiganaValiBox = required(target);
          if(furiganaValiBox) {
            target.after(`<p class="error">※${target.attr('data-valiName')}は${furiganaValiBox}</p>`);
          } else {
            target.siblings('.error').remove();
          }
        }
        break;
      case 'tel':
        const tel_replace = $(target).val().replace(/[^\d]+/g, '');
        target.val(tel_replace)
        if(!$(tel_replace).val()) {
          const numberVali = required(target);
          target.siblings('.error').remove();
          if(numberVali) {
            target.after(`<p class="error">※${target.attr('data-valiName')}は${numberVali}</p>`);
          } else {
            target.siblings('.error').remove();
          }
        } else {
          const telBox = tel(target);
          target.siblings('.error').remove();
          if(telBox) {
            target.after(`<p class="error">※${telBox}</p>`)
          } else {
            target.siblings('.error').remove();
          }
        }
        break;
      case 'email':
        if(!$(target).val()) {
          const mailVali = required(target);
          target.siblings('.error').remove();
          if(mailVali) {
            target.after(`<p class="error">※${target.attr('data-valiName')}は${mailVali}</p>`);
          } else {
            target.siblings('.error').remove();
          }
        } else {
          const mailBox = mail(target);
          if(mailBox) {
            target.after(`<p class="error">※${mailBox}</p>`)
          } else {
            target.siblings('.error').remove();
          }
        }
        break;
    }
  });

  /**
   * 空判定のバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function required(target) {
    let error = '';
    if(!$(target).val()) {
      return error = '必須項目です。';
    }
  }

  /**
   * フリガナのバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function furigana(target) {
    let error = '';
    if(!$(target).val().match(/^[ァ-ヶー　]*$/)) {
      return error = 'カタカナで入力してください。';
    }
  }

  /**
   * 電話番号のバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
  function tel(target) {
    let error = '';
    // if (!$(target).val().match(/^0\d{1,4}-\d{1,4}-\d{3,4}$|^\d{9,13}$/)) {
    if (!$(target).val().match(/^\d{9,13}$/)) {
    return error = '電話番号に誤りがあります。';
    }
  }

  /**
   * メールのバリデーション
   * @param  {[type]} target [description]
   * @return {[type]}        [description]
   */
    function mail(target) {
      let error = '';
      if(!$(target).val().match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)){
        return error = 'メールアドレスに誤りがあります。';
      }
    }
});